/**
 * Custom Chart component terms
 *
 * @package ext-components-pro
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const fluentUi = {
	component: {
		label: "component:fluentUi#label",
		description: "component:fluentUi#description"
	}
};
